<template>
  <div>
    <!--<left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>-->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <!--<v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>-->
        <v-row>
        <v-col cols="12">
             <left-emp-menu></left-emp-menu>
        </v-col>
          <v-col>
            <v-row >
            <v-col cols="12">
                <v-list three-line subheader>

                     <!-- ADD -->
                    <v-dialog v-model="dialogAdd" persistent max-width="80%">
                      <v-card>
                        <v-card-title>
                          <span class="headline">เพิ่มข้อมูล</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                          <v-form
                            ref="form_add"
                            v-model="valid_add"
                            lazy-validation
                          >
                            <v-row>
                              <v-col cols="12" sm="4">
                                    <v-select
                                        :items="
                                        EducationLevel
                                        "
                                        v-model="
                                        formAdd.educationLevel
                                        "
                                        :rules="nameRules"
                                        label="ระดับการศึกษา *"
                                        placeholder="Select..."
                                        required
                                        dense
                                        outlined
                                    ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                    <v-text-field
                                         v-model="formAdd.educationAddress"
                                        label="ชื่อสถานศึกษา *"
                                        :counter="100"
                                        maxlength="100"
                                        :rules="nameRules"
                                        required
                                        dense
                                        outlined
                                    />
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                    <v-select
                                        :items="
                                        Education_Group
                                        "
                                        v-model="
                                        formAdd.educationAcademyGroup
                                        "
                                        :rules="nameRules"
                                        label="กลุ่มสถาบันการศึกษา *"
                                        placeholder="Select..."
                                        required
                                        dense
                                        outlined
                                    ></v-select>
                                    </v-col>

                                    <v-col
                                    cols="12"
                                    md="4"
                                    >
                                    <v-text-field
                                        v-model="
                                        formAdd.educationFaculty
                                        "
                                        label="คณะ/หลักสูตร"
                                        :counter="50"
                                        maxlength="50"
                                        required
                                        dense
                                        outlined
                                    />
                                    </v-col>

                                    <v-col
                                    cols="12"
                                    md="4"
                                    >
                                    <v-text-field
                                        v-model="
                                        formAdd.educationDepartment
                                        "
                                        label="สาขาวิชา"
                                        :counter="50"
                                        maxlength="50"
                                        required
                                        dense
                                        outlined
                                    />
                                    </v-col>

                                    <v-col
                                    cols="12"
                                    md="4"
                                    >
                                    <v-text-field
                                        v-model="
                                        formAdd.educationYear
                                        "
                                        label="ปีที่จบ"
                                        :counter="4"
                                        maxlength="4"
                                        required
                                        dense
                                        outlined
                                    />
                                    </v-col>

                                    <v-col
                                    cols="12"
                                    md="4"
                                    >
                                    <v-text-field
                                        v-model="formAdd.educationGrade"
                                        label="เกรดเฉลี่ย (GPA.)"
                                        :counter="4"
                                        maxlength="4"
                                        required
                                        dense
                                        outlined
                                    />
                                    </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    :items="itemStatus"
                                    v-model="formAdd.educationStatus"
                                    label="สถานะการศึกษา *"
                                    :rules="nameRules"
                                    placeholder="Select..."
                                    required
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>
                            </v-row>
                            </v-form>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            elevation="2"
                            x-large
                            color="dark darken-1"
                            text
                            @click="dialogAdd = false"
                          >
                            <v-icon left> mdi-cancel</v-icon>
                            ปิด
                          </v-btn>
                          <v-btn
                            elevation="2"
                            x-large
                            color="success"
                            text
                            :disabled="!valid_add"
                            @click="addData()"
                          >
                            <v-icon left>mdi-checkbox-marked-circle</v-icon>
                            เพิ่ม
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <!-- end add -->

                    <v-alert v-if="dataEducation.length == 0"
                      border="right"
                      colored-border
                      type="error"
                      elevation="20"
                    >
                      กรุณาเพิ่มข้อมูลประวัติการศึกษา อย่างน้อย 1 รายการ  Please enter  at least 1 item.
                    </v-alert>

                    <v-alert v-if="dataEducation.length >= 4"
                      text
                      dense
                      color="red"
                      icon="mdi-clock-fast"
                      border="left"
                    >
                      * ระบุการศึกษา ได้สูงสุด <strong>5</strong> อันดับเท่านั้น!.
                    </v-alert>

                    <v-card-title class="header_1">
                    ประวัติการศึกษา
                    <v-icon color="#871B12">mdi-account-circle-outline </v-icon>
                    <v-spacer></v-spacer>
                       <v-col class='text-right'>
                      <v-btn
                        v-if="rollHR" color="primary" depressed @click="dialogAdd = true , validate('ADD')">
                        <v-icon left>mdi-text-box-plus</v-icon>
                        เพิ่มข้อมูล
                      </v-btn>
                      </v-col>
                  </v-card-title>
                  จำนวน {{dataEducation.length}} รายการ
                  <v-divider color="#871B12"></v-divider>

                    <div v-for="(items, index) in dataEducation" :key="index">
                      <v-card elevation="20">
                           <v-subheader> {{items.educationAddress}} <v-icon>mdi-cast-education</v-icon>
                          <v-col class="text-right">
                              <v-btn v-if="rollHR" small color="error" @click="deleteEducation(items)">
                                <v-icon small>mdi-close</v-icon>
                                  ลบข้อมูล
                              </v-btn>
                          </v-col>
                        </v-subheader>
                            <v-divider></v-divider>
                            <v-card-text>
                            <v-form
                              ref="form_update"
                              v-model="valid_update"
                              lazy-validation
                            >
                            <v-container class="py-0">
                                <v-row>
                                    <v-col cols="12" sm="4">
                                    <v-select
                                        :items="
                                        EducationLevel
                                        "
                                        v-model="
                                        items.educationLevel
                                        "
                                        label="ระดับการศึกษา *"
                                        :disabled="!can"
                                        :rules="nameRules"
                                        placeholder="Select..."
                                        required
                                        dense
                                        outlined
                                    ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                     <v-text-field
                                        v-model="items.educationAddress"
                                        label="ชื่อสถานศึกษา *"
                                        :counter="100"
                                        maxlength="100"
                                        :disabled="!can"
                                        :rules="nameRules"
                                        required
                                        dense
                                        outlined
                                    />
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                    <v-select
                                        :items="Education_Group"
                                        v-model="items.educationAcademyGroup"
                                        label="กลุ่มสถาบันการศึกษา *"
                                        placeholder="Select..."
                                        :rules="nameRules"
                                        :disabled="!can"
                                        required
                                        dense
                                        outlined
                                    ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                    <v-text-field
                                        v-model="items.educationFaculty"
                                        label="คณะ/หลักสูตร"
                                        :counter="50"
                                        maxlength="50"
                                        required
                                        dense
                                        outlined
                                    />
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                    <v-text-field
                                        v-model="items.educationDepartment"
                                        label="สาขาวิชา"
                                        :counter="50"
                                        :readonly="!can"
                                        maxlength="50"
                                        required
                                        dense
                                        outlined
                                    />
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                    <v-text-field
                                        v-model="items.educationYear"
                                        label="ปีที่จบ"
                                        :counter="4"
                                        :readonly="!can"
                                        maxlength="4"
                                        required
                                        dense
                                        outlined
                                    />
                                    </v-col>

                                    <v-col
                                    cols="12"
                                    md="4"
                                    >
                                    <v-text-field
                                        v-model="items.educationGrade"
                                        label="เกรดเฉลี่ย (GPA.)"
                                        :counter="4"
                                        :readonly="!can"
                                        maxlength="4"
                                        required
                                        dense
                                        outlined
                                    />
                                    </v-col>

                                <v-col cols="12" sm="4">
                                  <v-select
                                    :items="itemStatus"
                                    v-model="items.educationStatus"
                                    label="สถานะการศึกษา *"
                                    :disabled="!can"
                                    :rules="nameRules"
                                    required
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>
                                </v-row>
                            <v-col cols='12' class='text-right' v-if="can">
                                  <v-btn
                                    color='success'
                                    class="mr-0"
                                    :disabled="!valid_update"
                                    @click="editDataEducation(items)"
                                  >
                                    แก้ไขข้อมูล
                                  </v-btn>
                                </v-col>
                              </v-container>
                            </v-form>
                          </v-card-text>
                          </v-card>
                          <br>
                          <br>
                          <br>
                    </div>
                          </v-list>
                    <v-row no-gutters>
              <v-footer fixed height="60px" color="#262A34">
                <v-col class='text-right'>
                <v-btn small
                  color="#E0E0E0"
                  @click="pushBack"
                >
                <v-icon left> mdi-arrow-left-circle-outline</v-icon>
                  ย้อนกลับ
                </v-btn>
                <v-btn small
                  color="#E0E0E0"
                  @click="pushNext"
                >
                  หน้าถัดไป
                  <v-icon right> mdi-arrow-right-circle-outline</v-icon>
                </v-btn>
              </v-col>
              </v-footer>
            </v-row>
            </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import EmpMenu from './EmployeeMenu.vue'
import educationLavel from '../../../assets/master/Education/educationLavel.json'
import educationGroup from '../../../assets/master/Education/educationGroup.json'
import educationAddress from '../../../assets/master/Education/educationAddressName.json'
export default {
  components: {
    'left-emp-menu': EmpMenu
  },
  created () {
  },
  data () {
    return {
      PK: '',
      rollHR: false,
      path: '/employee_education/', // Path Model
      // Menu Config
      breadcrumbs: [],
      // End Menu Config
      dataReady: true,
      valid_add: true,
      valid_update: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      search: '',
      dialogAdd: false,
      session: this.$session.getAll(),
      itemStatus: ['กำลังศึกษาอยู่', 'จบการศึกษา'],

      formAdd: {
        empCode: '',
        educationLevel: '',
        educationAddress: '',
        educationFaculty: '',
        educationDepartment: '',
        educationYear: '',
        educationGrade: '',
        educationStatus: '',
        educationAcademyGroup: ''
      },
      dataEducation: [],
      nameRules: [
        (v) => !!v || 'Input is required'
      ],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      EducationLevel: educationLavel,
      EducationAddressName: educationAddress,
      Education_Group: educationGroup,
      dataEmp: '',
      can: true
    }
  },
  async mounted () {
    this.dataReady = false
    await this.getGetTokenForEmployee()
    await this.checkEmpData()
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async checkEmpData () {
      this.can = localStorage.getItem('CanEdit')
      this.can = (this.can === 'true')
      if (localStorage.getItem('roll') === 'Employee') {
        this.dataEmp = JSON.parse(localStorage.getItem('data'))
      } else if (localStorage.getItem('roll') === 'HR') {
        this.rollHR = true
        this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      } else {
        this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      }
      if (localStorage.getItem('roll')) {
        await this.getDataByEducation()
      }
    },
    async getDataByEducation () {
      this.dataEducation = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "getEmpCode?empCode=" + this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            this.dataEducation = response.data
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataByEducation : ', error)
        })
    },
    async editDataEducation (dt) {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let id = dt.educationID
          let databylogin = localStorage.getItem('data')
          let ds = {
            educationLevel: dt.educationLevel,
            educationAddress: dt.educationAddress,
            educationFaculty: dt.educationFaculty,
            educationDepartment: dt.educationDepartment,
            educationYear: dt.educationYear,
            educationGrade: dt.educationGrade,
            educationStatus: dt.educationStatus,
            educationAcademyGroup: dt.educationAcademyGroup,
            LAST_USER: databylogin.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + id,
              ds,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.dataReady = true
              this.getDataByEducation()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async addData () {
      let databylogin = localStorage.getItem('data')
      //
      //
      //
      // สำหรับ เพิ่มข้อมูล
      // ต้องระบุ Create / Last User ว่าใครเป็นคนสร้าง
      //
      this.formAdd.CREATE_USER = databylogin.userName
      this.formAdd.LAST_USER = databylogin.userName

      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //
      //
      // กำหนด Code ของรายการ * อย่าลืมเปลี่ยน field
      //
      this.formAdd.empCode = this.dataEmp.empCode

      this.dataReady = false
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          delete this.formAdd['educationID']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "add",
              this.formAdd,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              if (response.status === 200) {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                this.dialogAdd = false
                this.dataReady = true
                this.clearData()
                this.getDataByEducation()
              }
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async deleteEducation (d) {
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async result => {
        let databylogin = localStorage.getItem('data')
        let ds = {
          LAST_USER: databylogin.userName
        }
        await axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + this.path + "delete/" + d.educationID,
            ds,
            {
              headers: {
                'Application-Key': localStorage.getItem('ApplicationKey')
              }
            }
          )
          .then(async (response) => {
            this.$swal('เรียบร้อย', 'ลบข้อมูล เรียบร้อย', 'success')
            this.getDataByEducation()
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            this.dataReady = true
            console.log('error function deleteDataGlobal : ', error)
          })
      })
        .catch((error) => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formAdd) {
        if (this.formAdd[key]) {
          this.formAdd[key] = ''
        }
      }
    },
    pushNext () {
      this.$router.push('/HRM/Employee/EmployeeExperience')
    },
    pushBack () {
      this.$router.push('/HRM/Employee/EmployeeFamily')
    }
  }
}
</script>
<style scope>
.scroll {
   overflow-y: scroll
}
.header_1 {
  font-family: Kanit;
  font-size: 20px;
  display: flex;

color: #871B12;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeeEducation.vue